<template>
    <div class="h-1 w-full">
        <div class="h-full min-h-[4px] w-full rounded bg-neutral-lighter">
            <div class="h-full rounded bg-primary" :style="{ width: percentage + '%' }"></div>
        </div>
    </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ProgressBar extends Vue {
    @Prop({ type: Number, default: 0 }) percentage;
}
</script>
